import React from 'react';
import Icon from '../../../../../../muiComponents/Icon';
import Tooltip from '../../../../../../muiComponents/Tooltip';

const IconSingleUse = () => {
    return (
        <div className='flex gap-5 flex-align-center'>
            <Icon
                iconName='Person'
                style={{
                    fontSize: 22,
                    color: 'var(--secondary-400)',
                }}
            />
            <Tooltip titleText={'single_use_allowed'}>
                <span>
                    <Icon
                        iconName={'InfoOutlined'}
                        sx={{
                            color: '#ffc107',
                            width: '12px',
                            height: '12px',
                            cursor: 'pointer',
                            marginBottom: '8px',
                        }}
                    />
                </span>
            </Tooltip>
        </div>
    );
};

export default IconSingleUse;
